module.exports = __webpack_public_path__ + "img/KinokoTable15.1f98117c.jpg";